var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M4.85547 12L6.26547 13.41L11.8555 7.83V20H13.8555V7.83L19.4455 13.41L20.8555 12L12.8555 4L4.85547 12Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
